import { render, staticRenderFns } from "./GraficoAlmacen.vue?vue&type=template&id=077246f0"
import script from "./GraficoAlmacen.vue?vue&type=script&lang=js"
export * from "./GraficoAlmacen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports